function allFalse(obj) {
  for (var i in obj) {
    if (obj[i] === true) return false;
  }
  return true;
}

export default allFalse;



// WEBPACK FOOTER //
// ./src/helpers/allFalse.js